var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"sn-nav-back"},[_c('a',{staticClass:"sn-iconbtn",attrs:{"href":"javascript:history.go(-1);"}},[_vm._v("返回")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.tit))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-804fa4b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/_topNav.vue
// module id = null
// module chunks = 